import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getNotificationOptionsForContext } from '../../config/notificationOptions';

const actions = getNotificationOptionsForContext('callMenuAfterHours');

const ConfigureNotificationForAfterHours = ({ open, onClose, callAction }) => {
  const handleSelectAction = (actionType) => {
    callAction(actionType)

    // You could also pass a callback to parent here if needed
    // onActionSelect(slot, actionType);

   onClose(false); // Close after selection
  };

  return (
    <Dialog open={open} onClose={()=> onClose(false)} maxWidth="xs" fullWidth 
        BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
      >
      <div className="px-4 pt-4 pb-1">
        <div className="flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-900">
            Configure Slot
            
          </h2>
          <IconButton onClick={()=> onClose(false)} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </div>

      <DialogContent className="pb-4">
        <div className="flex flex-col space-y-3">
          {actions.map((action, idx) => (
            <div
              key={idx}
              onClick={() => handleSelectAction(action.type)}
              className={`flex items-start space-x-3 p-3 rounded-lg ${
                idx === 0 ? 'bg-gray-50' : ''
              } hover:bg-gray-100 cursor-pointer transition`}
            >
              <div className="mt-1">{action.icon}</div>
              <div>
                <div className="text-sm font-medium text-gray-900">{action.title}</div>
                <div className="text-sm text-gray-500">{action.subtitle}</div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfigureNotificationForAfterHours;
